import { useTelephonyOmnichannelStore } from '@/stores/telephonyOmnichannel'
import { useChatStore } from '@/stores/chat'
import { startAudio, stopAudio } from '@/composables/telephony/omnivoip'

/**
 * @param {Object} data - v2.data from telephony_omnichannel WebSocket event
 */
export function handleTelephonyOmnichannelEvent(data) {
    const store = useTelephonyOmnichannelStore()
    const eventType = data?.type

    console.log('[TelephonyOmnichannel] Event:', eventType, data)

    switch (eventType) {
        case 'new_call':
            store.setIncomingCall(data)
            break

        case 'call_answered':
            if (store.callUuid === data?.uuid) {
                store.callStatus = 'answered'
                store._startTimer()
            }
            break

        case 'call_ended':
        case 'call_missed':
            if (store.callUuid === data?.uuid || store.hasActiveCall) {
                store.callStatus = 'ended'
                store._stopTimer()
                setTimeout(() => store.resetCall(), 2000)
            }
            break

        default:
            console.warn('[TelephonyOmnichannel] Unknown event type:', eventType, data)
    }
}

/**
 * @param {Object} data - data from call_status WebSocket event
 * data.call.call_id, data.call.kind, data.call.status
 */
export function handleCallStatusEvent(data) {
    const store = useTelephonyOmnichannelStore()
    const call = data?.call
    if (!call) return

    console.log('[TelephonyOmnichannel] call_status:', call.kind, call.status, call.call_id)

    switch (call.kind) {
        case 'active': {
            if (!store.hasActiveCall) return
            store.currentCall.callId = call.call_id
            if (store.callStatus !== 'answered') {
                store.callStatus = 'answered'
                store._startTimer()
            }

            let { serverType, serverUrl, apiId } = store.currentCall
            if (!apiId) {
                const channelId = store.currentCall.channel?.id
                if (channelId) {
                    const ch = useChatStore()().channels.find(c => c.id === channelId)
                    if (ch) {
                        apiId = ch.server_id || ch.api_id || ch.go_id
                        store.currentCall.apiId = apiId
                        if (!serverType) { serverType = ch.server_type; store.currentCall.serverType = serverType }
                        if (!serverUrl) { serverUrl = ch.server_url; store.currentCall.serverUrl = serverUrl }
                    }
                }
            }

            if (serverType && serverUrl && apiId) {
                setTimeout(() => {
                    if (store.callStatus === 'answered') {
                        startAudio(serverType, serverUrl, apiId, call.call_id)
                    }
                }, 1500)
            }
            break
        }

        case 'call_ended': {
            if (!store.hasActiveCall) return
            const activeCallId = store.currentCall?.callId || store.currentCall?.call?.uuid || store.currentCall?.uuid
            if (activeCallId && activeCallId !== call.call_id) return
            stopAudio()
            store.callStatus = 'ended'
            store._stopTimer()
            setTimeout(() => store.resetCall(), 2000)
            break
        }

        case 'outgoing_call':
        case 'incoming_call':
            break

        default:
            console.warn('[TelephonyOmnichannel] Unknown call_status kind:', call.kind)
    }
}
